const NOISE_FIELDS = new Set([
    'resource_modified_timestamp',
    'resource_modified_by',
    'modified_timestamp',
    'modified_by',
    'version',
]);

const NOISE_PATTERNS = [/^\$replace$/, /^\$set$/];

function isNoise(key: string): boolean {
    return NOISE_FIELDS.has(key) || NOISE_PATTERNS.some((p) => p.test(key));
}

export interface DiffEntry {
    path: string;
    type: 'added' | 'removed' | 'changed' | 'unchanged';
    oldVal?: unknown;
    newVal?: unknown;
}

export function computeDiff(
    oldObj: Record<string, unknown> | null,
    newObj: Record<string, unknown> | null,
    prefix = '',
    skipNoiseFilter = false,
): DiffEntry[] {
    const diffs: DiffEntry[] = [];
    const old = oldObj || {};
    const neu = newObj || {};
    const keys = Object.keys(old)
        .concat(Object.keys(neu))
        .filter((k, i, arr) => arr.indexOf(k) === i);

    for (const key of keys) {
        if (!prefix && !skipNoiseFilter && isNoise(key)) continue;
        const path = prefix ? `${prefix}.${key}` : key;
        const o = old[key];
        const n = neu[key];

        if (o === undefined || o === null) {
            if (n !== undefined && n !== null) {
                diffs.push({ path, type: 'added', newVal: n });
            } else {
                diffs.push({ path, type: 'unchanged', oldVal: o, newVal: n });
            }
        } else if (n === undefined || n === null) {
            diffs.push({ path, type: 'removed', oldVal: o });
        } else if (JSON.stringify(o) === JSON.stringify(n)) {
            diffs.push({ path, type: 'unchanged', oldVal: o, newVal: n });
        } else if (
            typeof o === 'object' &&
            typeof n === 'object' &&
            !Array.isArray(o) &&
            !Array.isArray(n)
        ) {
            diffs.push(
                ...computeDiff(
                    o as Record<string, unknown>,
                    n as Record<string, unknown>,
                    path,
                    skipNoiseFilter,
                ),
            );
        } else {
            diffs.push({ path, type: 'changed', oldVal: o, newVal: n });
        }
    }
    return diffs;
}
